import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector, connect } from "react-redux";
import CustomText from "pages/_components/CustomText/CustomText";
import DocumentUploader from "./_components/DocumentUploader"
import { push } from "connected-react-router";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";

const FORM_ID = "directDebit.loadRequest";

const LoadRequest = ({environment, fileId}) => {
    const dispatch = useDispatch();

    const { documentToUploadRequest = {}, externalUploadError = null} = useSelector(
        (state) => state.accounts,
    );

    const initialValues = {
    };

     const getDateFromFile = (document) => {
 
        if (!(document && document.status == "SUCCESS"))
           return null;

        const file = document?.value.documentId;
        const index = file?.indexOf("DDT");
        const dateStr = file?.slice(index + 3, index + 11);

        const year = parseInt(dateStr.slice(0, 4));
        const month = parseInt(dateStr.slice(4, 6)) - 1;
        const day = parseInt(dateStr.slice(6, 8));

        const formattedDate = `${String(day).padStart(2, '0')}/${String(month + 1).padStart(2, '0')}/${year}`;

        return formattedDate; 
    };


    const handleSubmit = () => {

          const documentToConfirm = {
            fileName: documentToUploadRequest?.value.documentId,
            date: getDateFromFile(documentToUploadRequest),
          };
          dispatch(accountsActions.setDocumentToConfirm(documentToConfirm));
          dispatch(push("/directDebit/confirm"));
    };

    const [formValues, setFormValues] = useState(initialValues);
    const [documentId, setDocumentId] = useState(null);

    const isFormComplete = () => {
        return documentId;
    };

    useEffect(() => {
            setDocumentId(documentToUploadRequest?.value?.documentId);
    }, [documentToUploadRequest]);


    return (
        <>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ isSubmitting, values }) => {
                setFormValues(values);
                return (
                    <Form>
                        <GridTable className="form">
                            <GridTable.Container columns={12} columnsTemplate="fixed">
                                <GridTable.Data columnStart={2} flexDirection="column" columnWidth={10} key={documentId}>
                                    <CustomText
                                        className="document-title"
                                        text={`${FORM_ID}.document.label`}
                                        textType="I18N"
                                    />
                                    <Field
                                        component={DocumentUploader}
                                        idForm={FORM_ID}
                                        name="directDebitDocument"
                                        label={`${FORM_ID}.upload.label`}
                                        extensionDocument="txt"
                                        documentCode={'1'}
                                        defaultDocument={{
                                            documentId: documentId,
                                            documentName: documentId,
                                        }}
                                        withDocumentName
                                        allowedTypes="txt"
                                        externalUploadError={externalUploadError}
                                        environmentCuit={environment.activeEnvironmentDocument}
                                        fileId={fileId}
                                    />

                                    
                                  
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={4}>
                                <Button
                                    type="submit"
                                    className="btn-primary"
                                    label="global.continue"
                                    loading={false}
                                    disabled={!isFormComplete()}
                                />
                            </Col>
                        </Row>
                    </Form>
                );
            }}
        </Formik>
        </>
    );
};

const mapStateToProps = (state) => ({
    environment: sessionSelectors.getActiveEnvironment(state),
    fileId: accountsSelectors.getDirectDebitFileId(state),
});
export default connect(mapStateToProps)(LoadRequest);